import { defineMessages } from 'react-intl';

export default defineMessages({
  home: 'Home',
  results: 'Results',
  administration: 'Administration',
  customerSettings: 'Account settings',
  demo: 'Demo',
  survey: 'Survey',
  surveys: 'Surveys',
  selectSurvey: 'Select a survey',
  question: 'Question',
  questions: 'Questions',
  surveyContent: 'Content',
  customer: 'Account',
  customers: 'Accounts',
  allCustomers: 'All accounts',
  selectCustomer: 'Select an account',
  changeCustomer: 'Change account',
  distribution: 'Distribution',
  distributions: 'Distributions',
  website: 'Website',
  websites: 'Websites',
  allWebsites: 'All websites',
  selectWebsite: 'Select a website',
  selectWebsites: 'Select websites',
  allUrls: 'All URLs',
  selectUrl: 'Select a url',
  settings: 'Settings',
  script: 'Script',
  scripts: 'Scripts',
  users: 'Users',
  userCount: `{count, plural,
    =0 {No users}
    one {1 user}
    other {# users}
  }`,
  license: 'License',
  licenses: 'Licenses',
  moduleLicense: 'Product license',
  moduleLicenses: 'Product licenses',
  module: 'Product',
  modules: 'Products',
  key: 'Key',
  text: 'Text',
  id: 'ID',
  name: 'Name',
  title: 'Title',
  description: 'Description',
  status: 'Status',
  type: 'Type',
  category: 'Category',
  categories: 'Categories',
  tools: 'Tools',
  options: 'Options',
  create: 'Create',
  created: 'Created',
  loading: 'Loading',
  cancel: 'Cancel',
  reset: 'Reset',
  goBack: 'Back',
  required: 'Required',
  mustBeNumber: 'The value is not a valid number',
  greaterThanX: 'The value has to be greater than {value}',
  lessThanX: 'The value has to be less than {value}',
  valuesGreaterThanX: 'You have to select at least {values} answers',
  valuesLessThanX: 'You can\'t select more than {values} answers',
  requiredUrl: 'Type a valid url `http(s)://www.example.com`',
  validEmail: 'Please insert a valid email address',
  validScriptKey: 'Please insert a valid script key. Only letters and numbers and hyphens is allowed.',
  minLength: 'Must be at least {value} characters',
  language: 'Language',
  languages: 'Languages',
  allLanguages: 'All languages',
  selectLanguage: 'Select a language',
  country: 'Country',
  countries: 'Countries',
  translation: 'Translation',
  translations: 'Translations',
  legacyId: 'Legacy ID',
  logout: 'Logout',
  support: 'Support',
  'en-GB': 'English',
  'sv-SE': 'Svenska',
  'nb-NO': 'Norsk',
  general: 'General survey',
  feedback: 'Feedback',
  targeted: 'Targeted survey',
  cx: 'CX survey',
  generalSurveys: 'General surveys',
  targetedSurveys: 'Targeted surveys',
  cxSurveys: 'CX surveys',
  traffic: 'Traffic',
  successfullFormFeedback: 'Saved successfully',
  errorFormFeedback: 'Error: Something went wrong.',
  search: 'Search',
  segments: 'Segments',
  date: 'Date',
  empty: 'Empty',
  edit: 'Edit',
  save: 'Save',
  ok: 'OK',
  delete: 'Delete',
  confirmDelete: 'Are you sure you want to delete {title}?',
  remove: 'Remove',
  confirmRemove: 'Are you sure you want to remove {title}?',
  duplicate: 'Duplicate',
  next: 'Next',
  back: 'Back',
  done: 'Done',
  reports: 'Reports',
  report: 'Report',
  meta: 'Meta',
  docs: 'Docs',
  flaggedComments: 'Flagged Comments',
  blacklistWords: 'Blacklist Words',
  whitelistWords: 'Whitelist Words',
  word: 'Word',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
  closeLoading: 'Close',
  loadingDescription: 'Please wait a few moments while the content is loaded.',
  closeLoadingTooltip: 'Close Loading and continue. The result can still show up even if you close.',
  week: 'week',
  staticSegmentName: 'All',
  legacy: 'Legacy',
  defaultTheme: 'Default',
  darkTheme: 'Dark',
  customTheme: 'Custom',
  mobile: 'Mobile',
  tablet: 'Tablet',
  desktop: 'Desktop',
  industries: 'Industries',
  industry: 'Industry',
  and: 'and',
  or: 'or',
  viewDetails: 'View details',
  files: 'Files',
  guides: 'Knowledge base',
  dataSource: 'Data source',
  dataSources: 'Data sources',
  allDataSources: 'All data sources',
  selectDataSource: 'Select a data source',
  heatmaps: 'Heatmaps',
  heatmap: 'Heatmap',
  sessionRecordings: 'Recordings',
  sessionRecording: 'Recording',
  version: 'Version',
  internal: 'Global',
  partner: 'Partner',
  globalBenchmark: 'Global (all surveys)',
  benchmark: 'Benchmark',
  yearly: 'Yearly',
  monthly: 'Monthly',
  trial: 'One month free trial',
  unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  ANALYTICS: 'Analytics',
  HEATMAPS: 'Heatmaps & recordings',
  UX_SURVEYS: 'UX surveys',
  CX_SURVEYS: 'CX surveys',
  ADDON: 'Addon',
});
